import styled from "styled-components"
import AnimatedValue from "./AnimatedValue"

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 24px 24px 0;
  height: 72px;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  min-width: 110px;
`

const CardLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`

const CardValueRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: baseline;
`

const CardValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  color: white;
`

const CardUnit = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.6);
`

const Divider = styled.div`
  width: 1px;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
`

const SummaryCards = ({
  weeklyTotal,
  avgDaily,
  unit,
  loading,
}: {
  weeklyTotal: number
  avgDaily: number
  unit: string
  loading: boolean
}) => {
  return (
    <Wrapper>
      <Card>
        <CardLabel>Weekly Total</CardLabel>
        <CardValueRow>
          <CardValue>
            <AnimatedValue value={weeklyTotal} loading={loading} />
          </CardValue>
          <CardUnit>{unit}</CardUnit>
        </CardValueRow>
      </Card>
      <Divider />
      <Card>
        <CardLabel>Avg. Daily</CardLabel>
        <CardValueRow>
          <CardValue>
            <AnimatedValue value={avgDaily} loading={loading} />
          </CardValue>
          <CardUnit>{unit}</CardUnit>
        </CardValueRow>
      </Card>
    </Wrapper>
  )
}

export default SummaryCards
